import PageTopTitle from "../../components/shared/PageTopTitle";
import styled from "styled-components";
import UetdsYukBildirimiUserControlPage from "../../components/uetdsPages/UetdsYukBildirimiUserControlPage";
import UETDSYukBildirimiPage from "../../components/uetdsPages/UetdsYukBildirimiPage";

const Container = styled.div`
  width: 100%;
  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      margin: 0 30px;
      margin-top: 20px;
      color: ${({ theme }) => theme.mainTextColor};
      @media (max-width: 1550px) {
        margin: 0;
        margin-top: 0;
        padding: 20px 30px 0px;
        overflow: auto;
      }
      .titles {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(9, 1fr) 0.5fr;
        text-align: center;
        text-align: center;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);

        .col{
          text-align: center !important;
          flex: 1;
          color: ${({ theme }) => theme.mainTextColor};
        }

        .col-sm{
          flex: .3;
        }

      }
      .btn-group {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 20px;
      }

      .filter-container {
        width: 100%;
        height: auto;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0;
        @media (max-width: 1550px) {
          flex-direction: column;
        }
        .button-container {
          display: flex;
          align-items: center;
          gap: 5px;
          margin-left: 10px;
          @media (max-width: 1550px) {
            margin-top: 15px;
          }
        }

        .filter-input-grp {
          margin: 0 2px;
          display: flex;
          gap: 20px;
          @media (max-width: 1550px) {
            align-items: center;
            justify-content: center;
            margin: 0 auto;
          }
        }
      }
    }
  }
`;

const UETDSYukBildirimiLojistik = () => {
  
  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"U-ETDS Yük Bildirimi"} position="sticky" />
        <div className="content">
          <UetdsYukBildirimiUserControlPage />

          <UETDSYukBildirimiPage />
        </div>
      </div>
    </Container>
  );
};

export default UETDSYukBildirimiLojistik;
